import {
  CompressOutlined,
  ExpandOutlined,
  EditOutlined,
  AppstoreOutlined,
  SafetyOutlined,
} from '@ant-design/icons';

/** @typedef {{ key: string, op: string, label: string, icon: React.ComponentType, extra?: object }} AssistAction */

/** @type {AssistAction[]} */
export const ASSIST_ACTIONS = [
  { key: 'shorten', op: 'shorten', label: 'Shorten', icon: CompressOutlined },
  { key: 'expand', op: 'expand', label: 'Expand', icon: ExpandOutlined },
  { key: 'improve', op: 'improve', label: 'Improve', icon: EditOutlined },
  { key: 'structure', op: 'structure', label: 'Structure', icon: AppstoreOutlined },
  { key: 'review', op: 'review', label: 'Review & harden', icon: SafetyOutlined },
];

export function resolveAssistAction(actionKey) {
  const action = ASSIST_ACTIONS.find((a) => a.key === actionKey);
  if (!action) return { op: actionKey, extra: {} };
  return { op: action.op, extra: action.extra || {} };
}

export function isAssistOpLoading(assistOp, actionKey) {
  return assistOp === actionKey;
}
